import { bytesToNDigits } from '@mail/cross-sizes-utils';
import classNames from 'clsx';
import { isNil } from 'ramda';
import React, { memo } from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import type { SizeProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

import styles from '../DataListItemRow.css';

export const Size = memo(function Size({ size }: SizeProps) {
    return (
        <div
            className={classNames(styles.size, {
                [styles.sizeResponsive]: ENABLE_FULL_RESPONSIVE,
            })}
        >
            {!isNil(size) && bytesToNDigits(size, 3).value}
        </div>
    );
});
